import { render, staticRenderFns } from "./productEntry.vue?vue&type=template&id=b4768eb0&scoped=true&"
import script from "./productEntry.vue?vue&type=script&lang=js&"
export * from "./productEntry.vue?vue&type=script&lang=js&"
import style0 from "./productEntry.vue?vue&type=style&index=0&id=b4768eb0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4768eb0",
  null
  
)

export default component.exports